import React, { DetailedHTMLProps, HTMLAttributes, ReactElement } from 'react';

interface IconProps extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {
    icon: string;
}

const iconPathsCountMap: Record<string, number> = {
    'opiconnect': 2,
    'opiconnect-blue': 2,
    'smiles-green-dot': 12,
    'desktop-green-dot': 4,
    'comment-green-dot': 7,
    'shop-green-dot': 17
};

const Icon: React.FC<IconProps> = ({ icon, className, ...props }): ReactElement => {
    const classes = [`opicon-${icon}`];
    const pathsCount = iconPathsCountMap[icon] || 0;

    if (className) {
        classes.push(className);
    }

    classes.sort();

    if (pathsCount === 0) {
        return <i className={classes.join(' ')} {...props} />;
    }

    const array = new Array(pathsCount).fill(0);

    return (
        <i className={classes.join(' ')} {...props}>
            {
                array.map((item, index) => <span key={`path${index + 1}`} className={`path${index + 1}`} />)
            }
        </i>
    );
};

export default Icon;
